import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../services/lds-user.service'

@Component({
    selector: 'lds-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    standalone: false
})
export class AboutComponent implements OnInit {

  constructor(private user: LdsUserService) { }

  ngOnInit() {
    this.user.currentModule = 'About';
  }

}
